import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { slugify } from "@cappelendamm/utils/slugify";
export function Typography({ as, children, className, variant = "body-base", muted, sensitive, id: definedId, ...rest }) {
    const Component = as ?? "p";
    const id = (definedId ??
        (typeof as === "string" &&
            ["h1", "h2", "h3", "h4", "h5", "h6"].includes(as) &&
            typeof children === "string"))
        ? slugify(children ? [children] : [])
        : undefined;
    return (_jsx(Component, { className: classNames({
            "cvr-title-2xl": variant === "title-2xl",
            "cvr-title-xl": variant === "title-xl",
            "cvr-title-lg": variant === "title-lg",
            "cvr-title-md": variant === "title-md",
            "cvr-title-sm": variant === "title-sm",
            "cvr-title-xs": variant === "title-xs",
            "cvr-title-kicker": variant === "title-kicker",
            "cvr-headline-3xl": variant === "headline-3xl",
            "cvr-headline-3xl italic": variant === "headline-3xl-italic",
            "cvr-headline-2xl": variant === "headline-2xl",
            "cvr-headline-2xl italic": variant === "headline-2xl-italic",
            "cvr-headline-xl": variant === "headline-xl",
            "cvr-headline-xl italic": variant === "headline-xl-italic",
            "cvr-headline-alt-3xl": variant === "headline-alt-3xl",
            "cvr-headline-alt-3xl italic": variant === "headline-alt-3xl-italic",
            "cvr-headline-alt-2xl": variant === "headline-alt-2xl",
            "cvr-headline-alt-2xl italic": variant === "headline-alt-2xl-italic",
            "cvr-headline-alt-xl": variant === "headline-alt-xl",
            "cvr-headline-alt-xl italic": variant === "headline-alt-xl-italic",
            "cvr-body-xl": variant === "body-xl",
            "cvr-body-2xl": variant === "body-2xl",
            "cvr-body-lg": variant === "body-lg",
            "cvr-body-base": variant === "body-base",
            "cvr-body-sm": variant === "body-sm",
            "cvr-body-xs": variant === "body-xs",
            "cvr-body-base-tight": variant === "body-base-tight",
            "cvr-body-sm-tight": variant === "body-sm-tight",
            "cvr-body-xs-tight": variant === "body-xs-tight",
            "cvr-label-lg": variant === "label-lg",
            "cvr-label-md": variant === "label-md",
            "cvr-label-sm": variant === "label-sm",
            "cvr-quote-lg": variant === "quote-lg",
            "cvr-quote-md": variant === "quote-md",
            "cvr-quote-sm": variant === "quote-sm",
            "text-muted": muted,
            "mm-hide rr-mask data-private mf-masked mf-listen": sensitive,
        }, className), id: id, ...rest, children: children }));
}
